export enum ModalKeys {
  AddressModal = 'address_modal',
  ShippingContactModal = 'shipping_contact_modal',
  Intro = 'intro',
  ShippingDiscountModal = 'shipping_discount_modal',
  TotalRefundModal = 'total_refund_modal',
}
